module.exports = __webpack_public_path__ + "img/bm.057be015.svg";